module.exports = __webpack_public_path__ + "static/media/nuclear-energy-permits-request.bf9af5cf.svg";